<template>
    <a
        class="icon-link"
        :href="href"
        :target="'_blank'"
        @click="handleClick">
        <Icon
            type="button-arrow"
            class="icon-link__icon"
            :height="13"
            :width="6.5" />
        {{ label }}
    </a>
</template>

<script>
export default {
    name: 'IconLink',
    props: {
        label: {
            type: String,
            required: true,
        },
        href: {
            type: String,
            required: false,
            default: '#',
        },
        preventDefaultClickEvent: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        handleClick (event) {
            if (this.preventDefaultClickEvent) {
                event.preventDefault();
                this.$emit('onClick');
            }
        },
    },
};
</script>

<style scoped lang="scss">
.icon-link {
  display: inline-block;
  @include font-migrosbank-bold();
  font-size: 16px;
  line-height: 19px;
  color: $interaction-green;
  cursor: pointer;

  @include media-breakpoint-down(xs) {
    font-size: 12px;
    line-height: 18px;
  }

  .icon-link__icon {
    margin-right: 5px;
    vertical-align: middle;

    ::v-deep path {
      stroke: $mb-grey5;
    }
  }

  &:hover {
    text-decoration: none;
    color: $mb-green-1;

    ::v-deep path {
      stroke: $mb-green-1;
    }
  }

  &:active {
    color: $mb-grey5;

    ::v-deep path {
      stroke: $mb-grey5;
    }

    @include media-breakpoint-down(xs) {
      color: $mb-green-1;

      ::v-deep path {
        stroke: $mb-green-1;
      }
    }
  }
}
</style>
